var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicateOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2188_43926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99922 4.8V1.6C4.99922 0.72 5.71922 0 6.59922 0H14.5992C15.0236 0 15.4305 0.168571 15.7306 0.468629C16.0306 0.768687 16.1992 1.17565 16.1992 1.6V9.6C16.1992 10.0243 16.0306 10.4313 15.7306 10.7314C15.4305 11.0314 15.0236 11.2 14.5992 11.2H11.3992V14.4C11.3992 14.8243 11.2306 15.2313 10.9306 15.5314C10.6305 15.8314 10.2236 16 9.79922 16H1.79922C1.37487 16 0.967906 15.8314 0.667848 15.5314C0.36779 15.2313 0.199219 14.8243 0.199219 14.4V6.4C0.199219 5.52 0.919219 4.8 1.79922 4.8H4.99922ZM6.59922 4.8H9.79922C10.2236 4.8 10.6305 4.96857 10.9306 5.26863C11.2306 5.56869 11.3992 5.97565 11.3992 6.4V9.6H14.5992V1.6H6.59922V4.8ZM1.79922 6.4V14.4H9.79922V6.4H1.79922ZM4.99922 9.6V8H6.59922V9.6H8.19922V11.2H6.59922V12.8H4.99922V11.2H3.39922V9.6H4.99922Z",
    fill: "#04245C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99844 9.6V8H6.59844V9.6H8.19844V11.2H6.59844V12.8H4.99844V11.2H3.39844V9.6H4.99844Z",
    fill: "#2173FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2188_43926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.199219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateOutline);
export default __webpack_public_path__ + "static/media/duplicate_outline.2976387688fa69b22541c0ce438f249b.svg";
export { ForwardRef as ReactComponent };